import React, { useState } from 'react'
import { Line } from 'react-chartjs-2'

interface Props {
  daysThisMonth: number,
  happyData: number[],
  angerData: number[],
  anxietyData: number[],
  sadData: number[],
  fearData: number[],
}

const options = {
  maintainAspectRatio: false,
  scales: {
    yAxes: [{
      gridLines: {
        display: true,
        color: "rgba(234,234,234,1)"
      },
      ticks: {
        beginAtZero: true,
        suggestedMax: 100,
        stepSize: 20
      }
    }],
    xAxes: [{
      gridLines: {
        display: false
      }
    }]
  },
  legend: {
    display: true,
    align: 'start' as const,
    labels: {
      boxWidth: 20
    }
  }
};

const EmotionGraph: React.FC<Props> = (props) => {
  const dataList = Array.from({length: props.daysThisMonth}, (_, k) => k + 1);

  const chartData = {
    labels: dataList,
    datasets: [
      {
        label: '喜び',
        fill: false,
        lineTension: 0.3,
        backgroundColor: 'rgba(250, 188, 46, 1)',
        borderColor: 'rgba(250, 188, 46, 1)',
        borderWidth: 2,
        pointBorderColor: 'rgba(250, 188, 46, 1)',
        pointBackgroundColor: 'rgba(250, 188, 46, 1)',
        pointBorderWidth: 1,
        pointHoverRadius: 4.5,
        pointHoverBackgroundColor: 'rgba(250, 188, 46, 1)',
        pointHoverBorderColor: 'rgba(250, 188, 46, 0.5)',
        pointHoverBorderWidth: 8,
        pointRadius: 4.5,
        pointHitRadius: 4.5,
        spanGaps: false,
        data: props.happyData
      },
      {
        label: '怒り',
        fill: false,
        lineTension: 0.3,
        backgroundColor: 'rgba(206, 81, 44, 1)',
        borderColor: 'rgba(206, 81, 44, 1)',
        borderWidth: 2,
        pointBorderColor: 'rgba(206, 81, 44, 1)',
        pointBackgroundColor: 'rgba(206, 81, 44, 1)',
        pointBorderWidth: 1,
        pointHoverRadius: 4.5,
        pointHoverBackgroundColor: 'rgba(206, 81, 44, 1)',
        pointHoverBorderColor: 'rgba(206, 81, 44, 0.5)',
        pointHoverBorderWidth: 8,
        pointRadius: 4.5,
        pointHitRadius: 4.5,
        spanGaps: false,
        data: props.angerData
      },
      {
        label: '不愉快',
        fill: false,
        lineTension: 0.3,
        backgroundColor: 'rgba(165, 49, 226, 1)',
        borderColor: 'rgba(165, 49, 226, 1)',
        borderWidth: 2,
        pointBorderColor: 'rgba(165, 49, 226, 1)',
        pointBackgroundColor: 'rgba(165, 49, 226, 1)',
        pointBorderWidth: 1,
        pointHoverRadius: 4.5,
        pointHoverBackgroundColor: 'rgba(165, 49, 226, 1)',
        pointHoverBorderColor: 'rgba(165, 49, 226, 0.5)',
        pointHoverBorderWidth: 8,
        pointRadius: 4.5,
        pointHitRadius: 4.5,
        spanGaps: false,
        data: props.anxietyData
      },
      {
        label: '恐れ',
        fill: false,
        lineTension: 0.3,
        backgroundColor: 'rgba(47, 60, 222, 1)',
        borderColor: 'rgba(47, 60, 222, 1)',
        borderWidth: 2,
        pointBorderColor: 'rgba(47, 60, 222, 1)',
        pointBackgroundColor: 'rgba(47, 60, 222, 1)',
        pointBorderWidth: 1,
        pointHoverRadius: 4.5,
        pointHoverBackgroundColor: 'rgba(47, 60, 222, 1)',
        pointHoverBorderColor: 'rgba(47, 60, 222, 0.5)',
        pointHoverBorderWidth: 8,
        pointRadius: 4.5,
        pointHitRadius: 4.5,
        spanGaps: false,
        data: props.fearData
      },
      {
        label: '悲しみ',
        fill: false,
        lineTension: 0.3,
        backgroundColor: 'rgba(0, 183, 216, 1)',
        borderColor: 'rgba(0, 183, 216, 1)',
        borderWidth: 2,
        pointBorderColor: 'rgba(0, 183, 216, 1)',
        pointBackgroundColor: 'rgba(0, 183, 216, 1)',
        pointBorderWidth: 1,
        pointHoverRadius: 4.5,
        pointHoverBackgroundColor: 'rgba(0, 183, 216, 1)',
        pointHoverBorderColor: 'rgba(0, 183, 216, 0.5)',
        pointHoverBorderWidth: 8,
        pointRadius: 4.5,
        pointHitRadius: 4.5,
        spanGaps: false,
        data: props.sadData
      }
    ]
  };

  return (
    <div className="emotion-graph">
      <Line data={chartData} options={options} />
    </div>
  )
}

export default EmotionGraph
